import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { ITrade } from "../interface/trade/ITrade";
import { IQueryTradeWalletBasicInfo } from "../interface/trade-wallet/IQueryTradeWalletBasicInfo";

import IWorkflowBasicInfo from "../interface/trade/IWorkflowBasicInfo";

enum TradeWalletSearchServiceEnum {
  getBasicInfo = "/",
  getTradeDetail = "/",
  getTradeAvailableStatus = "/status/available",
  getTradeStatus = "/{tradeId}/status",
  getTradeCotaStrategy = "/{tradeId}/strategy",
  searchTrades = "/filter",
  updateTradeWalletStatus = "/status",
  searchByReceivable = "/receivables",
  updateReceiptPayment = "/receipt-payment",
  rollbackReceiptPayment = "/receipt-payment/rollback"
}

export default class TradeWalletSearchService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/wallet/trade");
  }

  public getTradesBasicInfoTest = async (data: any): Promise<ITradeWalletBasicInfo[]> => Promise.resolve([{
    id: 10,
    amount: 1000.00,
    cedenteDocument: 'document',
    cedenteFullName: 'cedente full name',
    contractNumber: 'number',
    createdAt: '20/05/2023',
    isConvenio: false,
    convenioId: 1
  },
  {
    id: 1,
    amount: 1000000.00,
    cedenteDocument: 'document',
    cedenteFullName: 'cedente full name convenio',
    contractNumber: 'numberconvenio',
    createdAt: '20/05/2023',
    isConvenio: true,
    convenioId: 1000
  }] as ITradeWalletBasicInfo[]);

  public getTradesBasicInfo = async (queryData: IQueryTradeWalletBasicInfo): Promise<ITradeWalletBasicInfo[]> => await this.POST(TradeWalletSearchServiceEnum.getBasicInfo, { queryData });

  public getTradeDetail = async (tradeId: number): Promise<ITrade> => await this.GET(TradeWalletSearchServiceEnum.getTradeDetail + tradeId);
  public getTradeAvailableStatus = async (): Promise<ITrade> => await this.GET(TradeWalletSearchServiceEnum.getTradeAvailableStatus);

  public getTradeStatus = async (tradeId: number): Promise<ITrade> => await this.GET(TradeWalletSearchServiceEnum.getTradeStatus.replace("{tradeId}", `${tradeId}`));
  public getTradeCotaStrategy = async (tradeId: number): Promise<ITrade> => await this.GET(TradeWalletSearchServiceEnum.getTradeCotaStrategy.replace("{tradeId}", `${tradeId}`));

  public getTradeWalletReceivable = async (status: string): Promise<IWorkflowBasicInfo> => await this.GET(TradeWalletSearchServiceEnum.searchByReceivable + `?status=${status}`);

  public searchTrades = async (query: string): Promise<ITradeWalletBasicInfo[]> => await this.POST(TradeWalletSearchServiceEnum.searchTrades, { query });
  public updateTradeWalletStatus = async (payload: any): Promise<any> => await this.PUT(TradeWalletSearchServiceEnum.updateTradeWalletStatus, payload);

  public updateReceiptPayment = async data => await this.PUT(TradeWalletSearchServiceEnum.updateReceiptPayment, data);
  public rollbackReceiptPayment = async data => await this.PUT(TradeWalletSearchServiceEnum.rollbackReceiptPayment, data);
}



// WEBPACK FOOTER //
// ./src/services/api/TradeWalletSearch.service.ts